export default () => ({
  dashboard: {},
  overview: [],
  serviceOverview: [],
  pagination: {
    currentPage: 1,
    pageSize: 20,
    pageCount: 5,
    totalItems: 0,
  },
  serviceOverviewPagination: {
    currentPage: 1,
    pageSize: 20,
    pageCount: 5,
    totalItems: 0,
  },
  filters: {
    keyword: "",
    advanced: {
      title: null,
      service: [],
      branch: null,
      beneficiary: [],
      emplOfficerId: [],
      date: [],
      hasCV: null,
      relocate: null,
      languages: [],
      languageLevels: [],
      hasDrivingLicense: null,
      drivingLicense: null,
      projects: [],
    },
  },
  serviceOverviewFilters: {
    keyword: "",
    advanced: {
      title: null,
      service: [],
      branch: null,
      beneficiary: [],
      emplOfficerId: [],
      date: [],
    },
  },
});
